<template>
    <span v-clickaway="closeDropdown" class="app-make-referal-menu">
        <common-button
            :label="$t('common.microcopy.new')"
            type="add-referral"
            size="medium"
            :isClicked="isDropdownOpen"
            :icon="isDropdownOpen ? 'minus' : 'referral-add'"
            @click="toggleDropdown"
        ></common-button>

        <common-dropdown :isOpen="isDropdownOpen" :hasArrow="false" bgColor="gray" arrowPositionY="top" arrowPositionX="left">
            <common-dropdown-items :menuItems="menuItems" @item-clicked="itemClicked"></common-dropdown-items>
        </common-dropdown>
        <direct-referral
            v-if="isDirectReferralModalOpen"
            :activePracticeType="practiceType"
            @location-selected="toggleModal"
            @close="toggleModal"
        ></direct-referral>
    </span>
</template>

<script>
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            DirectReferral,
        },

        data() {
            return {
                isDropdownOpen: false,
                isDirectReferralModalOpen: false,
                selectedInsurance: [],
                PracticeTypeEnum: PracticeTypeEnum,
                practiceType: null,
            }
        },

        computed: {
            menuItems() {
                return [
                    {
                        name: this.$t('layouts.app.topnav.direct_referral'),
                        description: this.$t('layouts.app.topnav.direct_referral_description'),
                        icon: 'direct-referral',
                        subItems: [
                            {
                                name: this.$t('layouts.app.topnav.direct_physican'),
                                payload: { matchReferral: true, practiceType: PracticeTypeEnum.PHYSICIAN },
                            },
                            {
                                name: this.$t('layouts.app.topnav.direct_ancillary'),
                                payload: { matchReferral: true, practiceType: PracticeTypeEnum.ANCILLARY },
                            },
                        ],
                    },
                    {
                        name: this.$t('layouts.app.topnav.match_referral'),
                        description: this.$t('layouts.app.topnav.match_referral_description'),
                        icon: 'match-referral',
                        subItems: [
                            {
                                name: this.$t('layouts.app.topnav.match_physican'),
                                payload: {
                                    directReferral: true,
                                    practiceType: PracticeTypeEnum.PHYSICIAN,
                                    patientId: this.$route.params.id,
                                },
                            },
                            {
                                name: this.$t('layouts.app.topnav.match_ancillary'),
                                payload: { directReferral: true, practiceType: PracticeTypeEnum.ANCILLARY },
                            },
                        ],
                    },
                    {
                        name: this.$t('layouts.app.topnav.eprescribe'),
                        description: this.$t('layouts.app.topnav.eprescribe_description'),
                        icon: 'eprescribe',
                        payload: {
                            eprescribe: true,
                            route: 'referrals.eprescribe',
                            patientId: this.$route.params.id,
                        },
                        hidden: this.$auth.isUserPracticeOther(),
                        disabled: false,
                    },
                ]
            },
        },

        methods: {
            toggleDropdown() {
                this.isDropdownOpen = !this.isDropdownOpen
            },

            closeDropdown() {
                this.isDropdownOpen = false
            },

            toggleModal(practiceType) {
                this.practiceType = practiceType
                this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
            },

            changeInsurance(event) {
                this.selectedInsurance = event
            },

            openMatchReferral(practiceType, patientId = null) {
                const query = { practiceType: practiceType }
                if (patientId) {
                    query.patientId = patientId
                }
                this.$router.push({ name: `pool.new`, query })
            },

            itemClicked(payload) {
                if (payload.matchReferral) {
                    this.toggleModal(payload.practiceType)
                }
                if (payload.directReferral) {
                    this.openMatchReferral(payload.practiceType, payload.patientId)
                }

                if (payload.eprescribe) {
                    const query = {}
                    if (payload.patientId) {
                        query.patientId = payload.patientId
                    }
                    this.$router.push({ name: payload.route, query })
                }
            },
        },

        watch: {
            $route() {
                if (this.$route.query?.openModal?.length) {
                    this.toggleModal(this.$route.query.openModal)
                    const query = Object.assign({}, this.$route.query)
                    delete query.openModal
                    this.$router.replace({ query })
                }
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .app-make-referal-menu {
        @include breakpoint(tablet) {
            left: 10px;
        }
        .dropdown {
            @include breakpoint(smartphone-large) {
                left: 5px;
            }

            .app-user-dropdown__menu {
                @include breakpoint(smartphone-large) {
                    max-width: 100px;
                }
                &--item__submenu--items {
                    button {
                        height: 50px;
                    }
                }

                &--item__submenu {
                    @include breakpoint(smartphone-large) {
                        max-width: 200px;
                    }
                }
            }
        }
    }
</style>
